<template>
    <div class="PopUp">
        <div class="popup-content" style="padding-top:30px; padding-left:10px;">
            <div style="float:left; width:70%;">
            <h3 class="title">{{ApplicationPopupData.title}}</h3>
            <p>
                <span>{{ApplicationPopupData.text}}</span>
            </p>
            </div>
            <div style="float:left; padding-top:23px;" class="close-button" @click.prevent="closePopup">
                <font-awesome-icon class="font-awesome-icon" :icon="['far', 'times-circle']" size="lg"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ApplicationPopupData: {
                    title: null,
                    text: null
        }
    },

    methods: {
        closePopup: function() {
            this.$emit('close');
        }
    }
}
</script>